<template>
  <div class="row pl-3 pr-3 mb-3">
    <div class="col-12">
      <div
        class="row border rounded pt-2 pb-2 summary--section"
        :class="classes"
        v-show="
          showItems ||
          shouldDisplayOnCollectionSummary ||
          hasProductItemsAlready
        "
      >       
        <div class="col-12">
        <!-- Ticket: RP-127 | Date: 2021-05-20 | Author: THACH VO | Desc: UI Alighnment of service level pricing -->
          <div v-for="(product, index) in productList" :key="index">
            <div
              v-if="!product.isService || (!hideServices && product.isService)"
              class="row"
              :class="{
                'pl-3 ': !isMultipleServiceBookingEnabled && serviceExists && !product.isService,
                'pb-3 debug font-weight-bold':
                  !isMultipleServiceBookingEnabled &&
                  serviceExists &&
                  product.isService,
                'pt-3':
                  isMultipleServiceBookingEnabled &&
                  product.isServiceGroup &&
                  index > 0,
                'pt-1': isMultipleServiceBookingEnabled && product.isService,
                'font-weight-bold text-uppercase': product.isServiceGroup,
              }"
            >
              <!-- Label -->
              <div class="col-8" v-if="!isMultipleServiceBookingEnabled">
                <span v-html="buildName(product)"></span>
              </div>

              <!-- <div
                                v-if="isMultipleServiceBookingEnabled"
                                :class="{
                                    'col-8': product.isServiceGroup || (!product.isServiceGroup && !product.isService && !allProductsAreFree),
                                    'col-7': product.isService,
                                    'col-12': allProductsAreFree
                                }">
                                <span v-html="buildName(product)"></span>
                            </div> -->
              <template v-if="isMultipleServiceBookingEnabled">
                <template v-if="product.isServiceGroup">
                  <div class="col-8 text-black-50 pr-0">
                    <span v-html="buildName(product)"></span>
                  </div>
                  <div class="col-4 pl-0 d-flex align-items-center">
                    <hr class="m-0 w-100" />
                  </div>
                </template>
                <div
                  v-else-if="product.isService"
                  class="col-7 d-flex align-items-center font-weight-bold"
                >
                  <span
                    class="icon-simple icon-simple--circle icon-simple--bordered icon-simple--minus mr-1"
                    @click="removeProduct(product)"
                    v-show="!classes"
                  ></span>
                  <span v-html="buildName(product)"></span>
                </div>
                <div
                  v-else-if="
                    !product.isServiceGroup &&
                    !product.isService &&
                    !allProductsAreFree
                  "
                  class="col-8 d-flex align-items-center"
                >
                  <span
                    class="icon-simple icon-simple--circle icon-simple--bordered icon-simple--minus mr-1"
                    @click="removeProduct(product)"
                    v-show="!classes"
                  ></span>
                  <span v-html="buildName(product)"></span>
                </div>
                <div
                  v-else-if="
                    !product.isServiceGroup &&
                    !product.isService &&
                    allProductsAreFree
                  "
                  class="col-12 d-flex align-items-center"
                >
                  <span
                    class="icon-simple icon-simple--circle icon-simple--bordered icon-simple--minus mr-1"
                    @click="removeProduct(product)"
                    v-show="!classes"
                  ></span>
                  <span v-html="buildName(product)"></span>
                </div>
              </template>
              <!-- End Label -->

              <!-- Pricing, Booking Date, or Empty -->
              <div
                class="col-4 text-right font-weight-bold skiptranslate"
                v-if="
                  !isMultipleServiceBookingEnabled &&
                  selectedService.is_paid == 2
                "
              >
                ${{ (product.qty * product.price).toFixed(2) }}
              </div>

              <!-- <div
                                class="text-right"
                                v-if="isMultipleServiceBookingEnabled && (product.isService || (!product.isServiceGroup && !product.isService)) && !allProductsAreFree"
                                :class="{
                                    'col-4': product.isServiceGroup || (!product.isServiceGroup && !product.isService),
                                    'col-5 font-italic': product.isService,
                                    'font-weight-bold': !product.isServiceGroup && !product.isService
                                }">
                                {{ (!product.isServiceGroup && !product.isService ?
                                    (product.isPaid ?
                                        ('$' + (product.qty * product.price))
                                        : 'Free')
                                    : (product.isService ?
                                        product.bookingDate
                                        : '')) }}</div> -->
              <template v-if="isMultipleServiceBookingEnabled">
                <div
                  class="col-5 text-right font-italic pl-0"
                  v-if="product.isService"
                  v-html="product.bookingDate"
                />
                <div
                  class="col-4 text-right font-weight-bold skiptranslate"
                  v-if="
                    !product.isServiceGroup &&
                    !product.isService &&
                    product.isPaid
                  "
                >
                  {{ "$" + (product.qty * product.price).toFixed(2) }}
                </div>
                <div
                  class="col-4 text-right font-weight-bold skiptranslate"
                  v-if="
                    !product.isServiceGroup &&
                    !product.isService &&
                    !product.isPaid &&
                    !allProductsAreFree
                  "
                >
                  Free
                </div>
              </template>
            </div>
          </div>
          <!-- <div class="row">
                        <div class="col-8"><small>(1) Mattress and base (1 set only)</small></div>
                        <div class="col-4 text-right font-weight-bold">$32.18</div>
                    </div> -->
          <hr v-if="productList.length != 0 && showComputations" />
          <template v-if="showComputations">
            <div class="row">
              <div class="col-8">
                <span v-html="TEXTS.render(`BOOKING_SUMMARY_SUBTOTAL`)"></span>
              </div>
              <div class="col-4 text-right font-weight-bold skiptranslate">
                ${{ subTotal }}
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <span
                  v-html="TEXTS.render(`BOOKING_SUMMARY_COMPUTATION`)"
                ></span>
              </div>
              <div class="col-4 text-right font-weight-bold skiptranslate">
                ${{ gstComputation }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "../../../../helper";
import Texts from "../../../../common/utils/Texts";
import DateNoTz from "../../../../common/utils/DateNoTz";
import ServicePrices from "../../../../common/utils/ServicePrices";
import BookingSummaryMixin from "../../../../common/mixins/BookingSummaryMixin";
import IsDisplayCollectionSummaryMixin from "../../../../common/mixins/IsDisplayCollectionSummaryMixin";

export default {
  mixins: [BookingSummaryMixin, IsDisplayCollectionSummaryMixin],
  data() {
    return {
      subTotal: 0,
      gstComputation: 0,
      overAllTotal: 0,
      list: [],
      servicePrices: null,
    };
  },
  props: ["classes", "hideServices", "allPriceList"],
  methods: {
    buildName(product) {
      return helper.buildName(product);
    },
    buildNameLegacy(product) {
      if (product && product.isService) {
        return !this.hideServices ? `<b>${product.name}</b>` : null;
      }
      const stream = this.$store.getters.GET_WASTE_STREAM.list.find(
        (stream) =>
          stream.waste_stream_setting_id === product.waste_stream_setting_id
      );
      const variation = this.$store.getters.GET_WASTE_VARIATION.list.find(
        (variation) =>
          variation.waste_variation_id === product.waste_variation_id
      );
      const woiWaste = this.$store.getters.GET_WOI_WASTE.list.find(
        (woiWaste) =>
          woiWaste.waste_woi_waste_type_id === product.waste_woi_waste_type_id
      );
      const woiItem = this.$store.getters.GET_WOI_ITEM_TYPE.list.find(
        (woiItem) =>
          woiItem.waste_woi_item_type_id === product.waste_woi_item_type_id
      );

      const names = [];

      if (stream) {
        if (!product.invalid) {
          names.push("(" + product.qty + ")" + stream.waste_stream_name);
        }
      }

      if (variation && stream) {
        if (!product.invalid && stream.has_variation > 0) {
          names.push("(" + variation.variation_name + ")");
        } else {
          names.push("(" + product.qty + ")" + variation.variation_name);
        }
      }

      return names.join(" ");
    },
    bookSummaryDetails() {
      // bookingSummaryDetails dispatch to store in store bookingState
      let summaryDetails = {
        subTotal: this.subTotal,
        gstComputed: this.gstComputation,
        totalAmount: this.overAllTotal,
        list: this.getListWasteType,
      };

      this.$store.dispatch("bookingSummaryDetails", summaryDetails);
      this.$store.dispatch("setBookingState", { summaryDetails });
    },
    removeProduct(product) {
      if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

      // Current removing product not potentially part of current viewing product on your left side.
      if (
        this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id !==
        product.service_setting_id
      ) {
        if (product.isService) {
          this.$parent.$emit("showConfirmClearGroup", {
            service_group_id: product.service_group_id,
            service_setting_id: product.service_setting_id,
          });
        } else {
          // It's safe to remove the product in silence
          this.$store.dispatch(
            "removeActiveMultipleServiceSelectedBookingProducts",
            product
          );
        }
        this.removeCommentOfService(product.service_setting_id);
      } else {
        if (product.isService) {
          const productsCopy = this.getProductOfService(product);
          this.preselectNextService(product.service_setting_id, productsCopy);
        } else {
          const serviceSettingDeletedId = product.service_setting_id;
          const serviceWastesLength = this.getProductOfService({
            service_setting_id: product.service_setting_id,
          }).length;

          // Notify left component to remove the product programmatically
          this.$parent.$emit("removeProductFromSummary", [product]);

          // If we only had 1 waste and now we deleted it
          if (serviceWastesLength === 1) {
            this.getRemainingServices(serviceSettingDeletedId);
          }
        }
        this.removeCommentOfService(product.service_setting_id);
      }
    },
    getProductOfService(service) {
      const productsCopy = this.productList.filter(
        (product) =>
          !product.isServiceGroup &&
          !product.isService &&
          product.service_setting_id === service.service_setting_id
      );
      return productsCopy;
    },
    preselectNextService(serviceSettingDeletedId, productsCopy) {
      this.$parent.$emit("removeProductFromSummary", productsCopy);
      this.getRemainingServices(serviceSettingDeletedId);
    },
    selectNextService(nextSelectedData, id, callback, sec = 500) {
      const filterStr = `div[data-${nextSelectedData}-id="${id}"]`;
      setTimeout(() => {
        $(filterStr).click();
        if (callback) {
          callback();
        }
      }, sec);
    },
    remainedService(serviceSettingDeletedId) {
      return this.productList.filter(
        (p) => p.isService && p.service_setting_id !== serviceSettingDeletedId
      );
    },
    getRemainingServices(serviceSettingDeletedId) {
      const remainingServices = this.remainedService(serviceSettingDeletedId);
      if (remainingServices.length > 0) {
        const nextSelectedService =
          remainingServices[remainingServices.length - 1];

        if (
          nextSelectedService.service_group_id !==
          this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_group_id
        ) {
          let self = this;
          this.selectNextService(
            "service-group",
            nextSelectedService.service_group_id,
            function () {
              self.selectNextService(
                "service-setting",
                nextSelectedService.service_setting_id,
                null,
                1000
              );
            }
          );
        } else {
          this.selectNextService(
            "service-setting",
            nextSelectedService.service_setting_id
          );
        }
      }
    },
    removeCommentOfService(servicecId) {
      var bookingState = this.$store.getters.GET_BOOKING_STATE || {};
      var commentMap = bookingState.commentMap || {};
      delete commentMap[servicecId];
      this.$store.dispatch("setBookingState", { commentMap });
    },
  },
  watch: {
    productList: function () {
      this.bookSummaryDetails();
    },
  },
  computed: {
    TEXTS: () => Texts,
    getGST() {
      var gst = this.$store.getters.GET_GST_DEFAULT_DATA;
      return parseInt(gst.gst_setting_percent) / 100;
    },
    productList() {
      let totalAmount = 0;
      let allProducts = [];
      if (!this.isMultipleServiceBookingEnabled) {
        allProducts = this.$store.getters.GET_BOOKING_PRODUCTS.filter(
          (product) => !product.invalid
        );
        allProducts = allProducts.filter(
          (product) => !Number.isNaN(product.qty) && product.qty > 0
        );

        allProducts.forEach((product) => {
          totalAmount += product.qty * product.price;
        });
      } else {
        /************Multiple Service-Service Group Booking Enabled************/
        let getBooking = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.filter(
          (product) => !Number.isNaN(product.qty) && product.qty > 0
        );

        // NOTE: Object keys are now the service group id
        let allServiceGroups = helper.objectsGroupBy(
          this.$store.getters.GET_SERVICE_GROUP.list,
          "service_group_id"
        );

        // NOTE: Object keys are now the service setting id
        let allServices = helper.objectsGroupBy(
          this.$store.getters.GET_SERVICES.list,
          "service_setting_id"
        );

        let getBookingSchedule = (service_group_id, service_setting_id) => {
          const schedule = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES.find(
            (schedule) =>
              schedule.service_group_id == service_group_id &&
              schedule.service_setting_id == service_setting_id
          );

          if (schedule) {
            if (schedule.selectedPeriod instanceof Date) {
              const theDate = new DateNoTz(schedule.selectedPeriod);
              const desc = `${theDate.getMonthDescShort()} ${theDate.getDateWithZero()}`;
              return desc;
            }

            const startDate = new DateNoTz(schedule.selectedPeriod.start);
            const endDate = new DateNoTz(schedule.selectedPeriod.end);
            const desc = `${startDate.getMonthDescShort()} ${startDate.getDateWithZero()} - ${endDate.getMonthDescShort()} ${endDate.getDateWithZero()}`;

            return desc;
          }
          return "";
        };

        let subTotalCompute = ({ qty, price }) => qty * price;

        if (!this.servicePrices) {
          // Due to design, this component gets remounted everytime.
          // That's why sometimes this.servicePrices gets reinitialized to null
          // Good thing we're using a singleton class here so we could recyle
          // the single instance that was created before
          this.servicePrices = new ServicePrices();
        }

        const ProductGroupByServiceGroup = Object.entries(
          helper.objectsGroupBy(getBooking, "service_group_id")
        );
        for (var i = 0; i < ProductGroupByServiceGroup.length; i++) {
          const [
            service_group_id,
            productsGroupInService,
          ] = ProductGroupByServiceGroup[i];

          // We know that this entry is the service group level
          allProducts.push({
            name: allServiceGroups[service_group_id][0].group_name,
            isServiceGroup: true,
          });

          const ProductGroupByService = Object.entries(
            helper.objectsGroupBy(productsGroupInService, "service_setting_id")
          );
          for (var e = 0; e < ProductGroupByService.length; e++) {
            const [service_setting_id, products] = ProductGroupByService[e];
            const priceObject =
              this.servicePrices.allServices &&
              this.servicePrices.allServices.length > 0
                ? this.servicePrices.allServices.find(
                    (prices) => prices.service_setting_id == service_setting_id
                  )
                : null;

            // We know that this entry is the service setting level
            const serviceCopy = {
              name: allServices[service_setting_id][0].service_name,
              isService: true,
              qty: 1,
              price: Number((priceObject ? priceObject.price : 0) || 0),
              bookingDate: getBookingSchedule(
                service_group_id,
                service_setting_id
              ),
              service_group_id: Number(service_group_id),
              service_setting_id: Number(service_setting_id),
            };

            allProducts.push(serviceCopy);

            totalAmount += subTotalCompute(serviceCopy);

            products.forEach((product) => {
              // We know that this entry is the waste level
              const productCopy = {
                ...product,
                productNames: product.name,
              };
              allProducts.push(productCopy);
              totalAmount += subTotalCompute(product);
            }); // endforeach
          } // endfor
        } // endfor
      }

      //reassignValue to data
      this.overAllTotal = totalAmount.toFixed(2);
      this.subTotal = (totalAmount / (1 + this.getGST)).toFixed(2);
      this.gstComputation = (this.overAllTotal - this.subTotal).toFixed(2);

      return allProducts;
    },
    serviceExists() {
      let producList = this.productList;
      if (!producList || producList.length == 0) return false;
      return producList.find((product) => product.isService);
    },
    getListWasteType() {
      var data = [];
      (!this.isMultipleServiceBookingEnabled
        ? this.$store.getters.GET_BOOKING_PRODUCTS
        : this.$store.getters
            .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
      ).forEach((product) => {
        data.push(this.buildName(product));
      });
      return data;
    },
    allProductsAreFree() {
      return !this.isPaidOverall;
    },
    shouldDisplayOnCollectionSummary() {
      return this.isDisplayCollectionSummary && this.productList.length > 0;
    },
  },
};
</script>